var render, staticRenderFns
import script from "./StackBarChart.vue?vue&type=script&lang=js&"
export * from "./StackBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e064c0",
  null
  
)

export default component.exports